interface CourseCardDiscountBadgeProps {
  discount: number;
}

export function CourseCardDiscountBadge({ discount }: CourseCardDiscountBadgeProps) {
  return (
    <span className="bg-adipa-secondary rounded-md px-1.5 py-0.5 text-[0.68rem] font-semibold text-adipa-primary-foreground">
      -{discount}%
    </span>
  );
}
